/** AI APIs → Tasks (A7Y-5559): header only; the page is built out later (epic A7Y-5555). */
import { PageHeader } from '@/components/PageHeader';

export default function TasksPage() {
  return (
    <div className="px-4 py-0">
      <PageHeader title="Tasks" />
    </div>
  );
}
